import templateUrl from 'webutils/media/media-manager.htm'
import controller from 'webutils/media/media-manager.controller'

export default {
    controller,
    bindings: {
        realm: '@',
        accept: '@',
        icon: '@',
        size: '@',
        tags: '<?',
        criteria: '<?',
        tagCriteria: '<?',
        onSelect: '&',
        onAdd: '&',
    },
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl;
    }
};